/**
 * UGC video slider + portrait modal player
 * Carousel: native overflow scroll + pointer drag (not a third-party slider lib).
 */
(function () {
  'use strict';

  const DRAG_THRESHOLD = 6;

  /** Mouse/touch drag on horizontal scroll containers (works over child buttons). */
  function enableDragScroll(el) {
    let pointerId = null;
    let startX = 0;
    let scrollStart = 0;
    let dragged = false;

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      scrollStart = el.scrollLeft;
      dragged = false;
    });

    el.addEventListener('pointermove', (e) => {
      if (e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) <= DRAG_THRESHOLD) return;
      if (!dragged) {
        dragged = true;
        el.classList.add('is-dragging');
        el.style.scrollSnapType = 'none';
        try {
          el.setPointerCapture(e.pointerId);
        } catch (_) { /* ignore */ }
      }
      e.preventDefault();
      el.scrollLeft = scrollStart - dx;
    });

    const endDrag = (e) => {
      if (e.pointerId !== pointerId) return;
      try {
        if (el.hasPointerCapture(e.pointerId)) el.releasePointerCapture(e.pointerId);
      } catch (_) { /* ignore */ }
      pointerId = null;
      el.classList.remove('is-dragging');
      el.style.scrollSnapType = '';
      if (dragged) {
        el.dataset.wasDragged = 'true';
        window.setTimeout(() => {
          delete el.dataset.wasDragged;
        }, 400);
      }
    };

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('dragstart', (e) => e.preventDefault());
  }

  const modal = document.getElementById('UgcVideoModal');

  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  if (modal) {
  const closeBtns = modal.querySelectorAll('[data-ugc-close]');
  const playBtn = modal.querySelector('[data-ugc-play]');
  const muteBtn = modal.querySelector('[data-ugc-mute]');
  const progressBar = modal.querySelector('[data-ugc-progress]');
  const titleEl = modal.querySelector('[data-ugc-title]');
  const panels = Array.from(modal.querySelectorAll('[data-ugc-panel]'));

  let activePanel = null;
  let activeVideo = null;

  const setPlayIcon = (playing) => {
    if (!playBtn) return;
    playBtn.innerHTML = playing
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="8 5 19 12 8 19 8 5"/></svg>';
    playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  };

  const setMuteIcon = (muted) => {
    if (!muteBtn) return;
    muteBtn.innerHTML = muted
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';
    muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
  };

  const stopVideo = (video) => {
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  };

  const updateProgress = () => {
    if (!activeVideo || !progressBar) return;
    const pct = activeVideo.duration ? (activeVideo.currentTime / activeVideo.duration) * 100 : 0;
    progressBar.style.width = `${pct}%`;
  };

  const hydrateModalVideo = (video) => {
    if (!video || video.dataset.hydrated) return;
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
      changed = true;
    });
    if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      changed = true;
    }
    if (changed) video.load();
    video.dataset.hydrated = '1';
  };

  const showPanel = (index) => {
    panels.forEach((panel, i) => {
      const on = i === index;
      panel.hidden = !on;
      const video = panel.querySelector('video');
      if (!on && video) stopVideo(video);
    });
    activePanel = panels[index];
    if (!activePanel) return;

    activeVideo = activePanel.querySelector('video');
    const title = activePanel.dataset.title || '';
    const author = activePanel.dataset.author || '';

    if (titleEl) titleEl.textContent = title || author || 'Gwong';

    if (activeVideo) {
      hydrateModalVideo(activeVideo);
      activeVideo.setAttribute('playsinline', '');
      activeVideo.playsInline = true;
      activeVideo.muted = false;
      setMuteIcon(false);
      activeVideo.play().catch(() => {
        activeVideo.muted = true;
        setMuteIcon(true);
        activeVideo.play().catch(() => {});
      });
      setPlayIcon(!activeVideo.paused);
    }
    updateProgress();
  };

  const openModal = (index) => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    showPanel(index);
  };

  const closeModal = () => {
    panels.forEach((panel) => {
      const video = panel.querySelector('video');
      if (video) stopVideo(video);
      panel.hidden = true;
    });
    activePanel = null;
    activeVideo = null;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (progressBar) progressBar.style.width = '0%';
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ugc-open]');
    if (!btn) return;
    const carousel = btn.closest('[data-ugc-carousel]');
    if (carousel?.dataset.wasDragged === 'true') {
      e.preventDefault();
      return;
    }
    const index = parseInt(btn.dataset.ugcIndex, 10);
    if (!Number.isNaN(index)) {
      e.preventDefault();
      openModal(index);
    }
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  if (playBtn) {
    playBtn.addEventListener('click', () => {
      if (!activeVideo) return;
      if (activeVideo.paused) {
        activeVideo.play();
        setPlayIcon(true);
      } else {
        activeVideo.pause();
        setPlayIcon(false);
      }
    });
  }

  if (muteBtn) {
    muteBtn.addEventListener('click', () => {
      if (!activeVideo) return;
      activeVideo.muted = !activeVideo.muted;
      setMuteIcon(activeVideo.muted);
    });
  }

  modal.addEventListener('timeupdate', (e) => {
    if (e.target.matches('video')) updateProgress();
  }, true);
  }

  document.querySelectorAll('[data-ugc-slider]').forEach((section) => {
    const carousel = section.querySelector('[data-ugc-carousel]');
    if (!carousel) return;

    enableDragScroll(carousel);

    section.querySelectorAll('.cb-ugc-video__thumb-video').forEach((video) => {
      video.addEventListener('error', () => {
        const media = video.closest('.cb-ugc-video__thumb-media');
        if (!media || media.querySelector('img')) return;
        const poster = video.getAttribute('poster');
        if (!poster) return;
        const img = document.createElement('img');
        img.src = poster;
        img.alt = '';
        img.width = 270;
        img.height = 480;
        img.loading = 'lazy';
        img.decoding = 'async';
        video.replaceWith(img);
      });
    });

    const step = () => {
      const thumb = carousel.querySelector('.cb-ugc-video__thumb');
      return (thumb ? thumb.offsetWidth : 200) + 16;
    };

    const prevBtn = section.querySelector('[data-ugc-prev]');
    const nextBtn = section.querySelector('[data-ugc-next]');

    const updateNav = () => {
      if (window.Gwong?.utils?.updateScrollNav) {
        window.Gwong.utils.updateScrollNav(carousel, prevBtn, nextBtn);
      } else {
        const max = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        const atStart = carousel.scrollLeft <= 2;
        const atEnd = carousel.scrollLeft >= max - 2;
        if (prevBtn) prevBtn.hidden = max <= 2 || atStart;
        if (nextBtn) nextBtn.hidden = max <= 2 || atEnd;
      }
    };

    prevBtn?.addEventListener('click', () => {
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    });

    carousel.addEventListener(
      'scroll',
      () => requestAnimationFrame(updateNav),
      { passive: true }
    );
    window.addEventListener(
      'resize',
      window.Gwong?.utils?.debounce
        ? window.Gwong.utils.debounce(updateNav, 150)
        : updateNav
    );
    updateNav();
  });
})();
